import { render, staticRenderFns } from "./MFAv2.vue?vue&type=template&id=8bdec8ec&scoped=true"
import script from "./MFAv2.vue?vue&type=script&lang=js"
export * from "./MFAv2.vue?vue&type=script&lang=js"
import style0 from "./MFAv2.vue?vue&type=style&index=0&id=8bdec8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdec8ec",
  null
  
)

export default component.exports